export function stringNotNull(value: any): boolean {
    return value !== null && value !== undefined && value !== '';
}
